import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { FLEET_VEHICLE_TIRE_SEARCH_COLUMNS, FLEET_VEHICLE_TIRE_SET_SEARCH_COLUMNS } from "./consts";
import { VehicleTireSetSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import VehicleTireRowChild from "./components/VehicleTireRowChild";

const VehicleTireSetSearchResults: React.FC<VehicleTireSetSearchResultsProps> = (
  props
) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
    onLocationClick,
    onEditClick,
    onDemountClick
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_TIRE_SET_SEARCH_COLUMNS(t, onDeleteClick, onLocationClick, onEditClick, onDemountClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
          columnsChild={FLEET_VEHICLE_TIRE_SEARCH_COLUMNS(t)}
                CustomTableRowChild={(childProps) => (
                  <VehicleTireRowChild
                    {...childProps}
                    disableDelete
                    onFetchSearchResult={() =>
                      onPaginationChange?.(searchResults.pagination)
                    }
                  />
                )}
      />
    </>
  );
};
export default memo(VehicleTireSetSearchResults);
